(function ($) {
  $('button.btn-tgl-search').click(function () {
    var $elements = {
      'form': $('body'),
    };
  
    $('.js-search-input').focus();
    $('body').toggleClass('opened');
    $('.search-form').toggleClass('opened');
  }); // END Click Search
  
  if ($('.stycky-sidebar').length) {
    var offset_top = 20;

    if ($('.stycky-sidebar').lengt === 1) {
      $('.stycky-sidebar').stick_in_parent({
        offset_top: offset_top
      });
    } else {
      $('.stycky-sidebar').wrapAll('<div class="stycky-sidebar-wrapper"></div>');
      $('.stycky-sidebar-wrapper').stick_in_parent({
        offset_top: offset_top
      });
    }
  
    // $('.stycky-sidebar').each(function (i, e) {

    //   if (i > 0) {
    //     for (var j = 0; j < i; j++) {
    //       offset_top += $('.stycky-sidebar').eq(j).outerHeight() + 20;
    //     }
    //   } else {
    //     $(e).stick_in_parent({
    //       offset_top: offset_top
    //     });
    //   }
    // });
  }

  //play iframe
  $('.slot__cta').click(function() {
    $(this).hide();
    $('.slot-thumb').hide();
    $('.close-game').show();
    $('.slot-gameiframe').show();
    gameUrl = $('.slot-iframe').data('gameurl');
    $('.slot-iframe').attr('src' , gameUrl);
 });

  $('.close-game').click(function() {
    $('.slot-iframe').attr('src' , '');
    $('.slot-gameiframe').hide();
    $('.slot-thumb').show();
    $('.slot__cta').show();
    $('.close-game').hide();
 });

  $(document).on('click', '.js-more-facts', function () {
    $(this).prevAll('span').show();
    $(this).remove();
  });

  $('.js-btn-more').click(function (e) { 
    e.preventDefault();
    var wrap = $(this).closest('.js-more-items');
    var items = wrap.find('.js-more-item.d-none');

    items.toggleClass('d-none d-block');
    $(this).remove();
  });

  $('.js-glossary').click(function (e) { 
    e.preventDefault();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.filter__results__item').fadeIn(400);
    } else {
      var thisLetter = $(this).html();
      $('.js-glossary.active').removeClass('active');
      $(this).addClass('active');
      $('.filter__results__item').hide();
      $('.filter__results__item').each(function (i, e) {
        if ($(e).data('letter') === thisLetter) {
          $(e).fadeIn(400);
        } else {
          $(e).fadeOut(400);
        }
      });
    }
  });

  window.facts_more = function () {
    $('.js-facts-more').each(function (i, e) {
      var containerWidth = $(e).width() - 45;
      var spans = $(e).find('span');
      var spanWidth = 0;
      var moreItems = 0;
      var stop = false;

      if (!spans.length) {
        $(e).removeClass('text-nowrap');
      }

      $(spans).show();

      $(spans).each(function (k, span) {
        if (!stop && k > 0) {
          spanWidth = $(span).position().left + $(span).innerWidth();
        
          if (spanWidth >= containerWidth) {
            $(span).hide().nextAll('span').hide();
            moreItems = spans.length - k;
            stop = true;
          }
        }
      });

      if (stop) {
        $(e).removeClass('text-nowrap overflow-hidden').append('<button type="buttom" class="text-nowrap font-weight-bold js-more-facts">' + moreItems + ' more</button>');
      }
    });
  };

  function smoothScrolling(selector, offset_top) {

    offset_top = (offset_top) ? offset_top : 0;
    
    $(selector + '[href^="#"]:not([href="#"])').click(function() {
      var target = $(this.hash);

      if ( target.length ) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset_top //- header.outerHeight()
        }, 600);

        return false;
      }
    });
  }
  function currentSelect(selector) {
    var lastId,
      menu = $(selector),
      fromTop = $(this).scrollTop(),
      menuItems = menu.find("a.js-anchor"),
      scrollItems = menuItems.map(function() {
        var item = $($(this).attr("href"));
        if (item.length) {
          return item;
        }
      });
  
    // Get id of current scroll item
    var cur = scrollItems.map(function() {
      if (parseInt($(this).offset().top) <= fromTop && $(this).offset().top + $(this).outerHeight() >= fromTop)
        return this;
    });
  
    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";
    if (lastId !== id) {
      lastId = id;
      menuItems
        .parent().removeClass("current")
        .end().filter('[href="#' + id + '"]').parent().addClass("current");
    }
  }

  facts_more();
  smoothScrolling('.js-anchor');
  currentSelect('.js-anchors');

  $(window).resize(function () {
    $('.js-facts-more').addClass('text-nowrap overflow-hidden');
    $('.js-more-facts').remove();
    facts_more();
  });

  $(window).scroll(function () { 
    currentSelect('.js-anchors');
  });
})(jQuery);